// ============================================================================
// FALLBACK / OFFLINE DATA — Maa Florist Mumbai
// ----------------------------------------------------------------------------
// Everything in this file is used ONLY when REACT_APP_USE_LIVE_API=false or
// when a live API call fails (see services/api.js -> callOrMock).
// All real content — products, categories, site settings, testimonials,
// shapes, banners — is managed from the admin panel. Do NOT edit this file
// expecting changes to appear on the live site.
// ============================================================================

const dining = [
  'https://images.unsplash.com/photo-1633435597188-27c1e70f329d?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1617638924751-cc232f82ecf9?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1615529162924-f8605388461d?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1617638717732-a3ef01769ff2?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1614597445336-8a67e9314d91?auto=format&fit=crop&w=1200&q=80',
];
const clocks = [
  'https://images.pexels.com/photos/11066021/pexels-photo-11066021.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/7258058/pexels-photo-7258058.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/7256845/pexels-photo-7256845.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/1181419/pexels-photo-1181419.jpeg?auto=compress&cs=tinysrgb&w=1200',
];

// ---------------------------------------------------------------------------
// Hero slides — fallback for getHeroSlides(). Real slides: admin > Banners.
// ---------------------------------------------------------------------------
export const heroSlides = [
  {
    title: 'Handcrafted Epoxy Resin Art',
    subtitle: 'India\u2019s No.1 Resin Brand \u2014 Where wood meets waves.',
    cta: 'Shop Collection',
    image: 'https://images.unsplash.com/photo-1633435597188-27c1e70f329d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxlcG94eSUyMHJlc2luJTIwdGFibGV8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    title: 'Ocean Shore Dining Collection',
    subtitle: 'Bring the sea home \u2014 live-edge epoxy dining tables.',
    cta: 'Explore Dining Tables',
    image: 'https://images.unsplash.com/photo-1617638924751-cc232f82ecf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxlcG94eSUyMHJlc2luJTIwdGFibGV8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85',
  },
];

// ---------------------------------------------------------------------------
// Testimonials — fallback for getTestimonials(). Real data: admin > Testimonials.
// ---------------------------------------------------------------------------
export const testimonials = [
  {
    name: 'Ananya Sharma',
    city: 'Andheri',
    text: 'The red roses were incredibly fresh and beautifully arranged. The bouquet looked even better than the photos!',
    rating: 5
  },
  {
    name: 'Rahul Verma',
    city: 'Bandra',
    text: 'Ordered a rose bouquet for my wife’s birthday. The flowers arrived fresh and perfectly packed. She loved them!',
    rating: 5
  },
  {
    name: 'Priya Nair',
    city: 'Powai',
    text: 'The pink lilies were gorgeous and had such a lovely fragrance. Beautiful flowers and excellent service.',
    rating: 4
  },
  {
    name: 'Vikram Shah',
    city: 'Thane',
    text: 'Ordered a mixed flower bouquet for my mother. The colours were beautiful and the flowers were very fresh.',
    rating: 5
  },
  {
    name: 'Neha Kapoor',
    city: 'Borivali',
    text: 'The red and white rose bouquet was absolutely beautiful. Perfectly arranged and delivered on time.',
    rating: 4.5
  },
  {
    name: 'Rohan Mehta',
    city: 'Goregaon',
    text: 'Really impressed with the freshness of the roses. The bouquet looked premium and elegant.',
    rating: 5
  },
  {
    name: 'Sneha Patel',
    city: 'Kandivali',
    text: 'Ordered flowers for my sister’s birthday. She loved the pink roses and the beautiful wrapping.',
    rating: 5
  },
  {
    name: 'Amit Joshi',
    city: 'Malad',
    text: 'The bouquet arrived fresh and beautifully arranged. Great option for sending flowers in Mumbai.',
    rating: 4.8
  },
  {
    name: 'Pooja Mehta',
    city: 'Mulund',
    text: 'The orchid bouquet was stunning. Fresh flowers, beautiful presentation and very good service.',
    rating: 5
  },
  {
    name: 'Kunal Desai',
    city: 'Ghatkopar',
    text: 'The red roses were fresh, bright and nicely packed. My wife was really happy with the surprise.',
    rating: 4
  },
  {
    name: 'Riya Singh',
    city: 'Chembur',
    text: 'Beautiful mixed flowers and excellent presentation. The bouquet made my mother’s birthday extra special.',
    rating: 5
  },
  {
    name: 'Arjun Malhotra',
    city: 'Vile Parle',
    text: 'Ordered a bouquet of roses and lilies. Everything looked fresh and the arrangement was beautiful.',
    rating: 4.5
  },
  {
    name: 'Kavya Iyer',
    city: 'Santacruz',
    text: 'The pink roses were gorgeous and very fresh. The bouquet was exactly what I wanted.',
    rating: 5
  },
  {
    name: 'Siddharth Jain',
    city: 'Khar',
    text: 'Excellent flower quality. The bouquet was beautifully arranged and delivered as promised.',
    rating: 5
  },
  {
    name: 'Meera Kulkarni',
    city: 'Juhu',
    text: 'The flower arrangement looked elegant and luxurious. Perfect for an anniversary surprise.',
    rating: 4
  },
  {
    name: 'Nisha Agarwal',
    city: 'Andheri West',
    text: 'Loved the combination of roses and orchids. The colours looked beautiful together.',
    rating: 5
  },
  {
    name: 'Manish Gupta',
    city: 'Andheri East',
    text: 'The bouquet was fresh and nicely wrapped. Delivery was smooth and the flowers looked amazing.',
    rating: 4.8
  },
  {
    name: 'Ishita Roy',
    city: 'Dadar',
    text: 'Ordered flowers for my parents’ anniversary. The arrangement was beautiful and they loved it.',
    rating: 5
  },
  {
    name: 'Saurabh Mishra',
    city: 'Worli',
    text: 'The premium rose bouquet looked fantastic. Fresh flowers and excellent presentation.',
    rating: 4.5
  },
  {
    name: 'Tanvi Shah',
    city: 'Lower Parel',
    text: 'The bouquet was absolutely gorgeous. The roses were fresh and the packaging looked very elegant.',
    rating: 5
  },
  {
    name: 'Ayesha Khan',
    city: 'Mira Road',
    text: 'Ordered a colourful flower basket for my sister. She loved it! Fresh flowers and beautiful arrangement.',
    rating: 5
  },
  {
    name: 'Harsh Mehta',
    city: 'Bhayandar',
    text: 'Very happy with the flower quality. The roses were fresh and the bouquet looked lovely.',
    rating: 5
  },
  {
    name: 'Komal Jain',
    city: 'Vasai',
    text: 'The pink lily bouquet was beautiful and fresh. It was delivered nicely packed.',
    rating: 4
  },
  {
    name: 'Deepak Sharma',
    city: 'Vasai West',
    text: 'Ordered flowers for my wife’s birthday. The bouquet was beautiful and she absolutely loved it.',
    rating: 5
  },
  {
    name: 'Pallavi Nair',
    city: 'Virar',
    text: 'The mixed roses bouquet was colourful, fresh and beautifully arranged. Great experience.',
    rating: 4.5
  },
  {
    name: 'Akash Yadav',
    city: 'Nalasopara',
    text: 'Very fresh roses and good packaging. The bouquet looked exactly as expected.',
    rating: 5
  },
  {
    name: 'Divya Menon',
    city: 'Virar West',
    text: 'The flower basket was gorgeous. Lots of fresh flowers and a very attractive arrangement.',
    rating: 5
  },
  {
    name: 'Rajiv Kapoor',
    city: 'Naigaon',
    text: 'Ordered a bouquet of red roses and white lilies. Beautiful combination and excellent freshness.',
    rating: 4.8
  },
  {
    name: 'Aman Sinha',
    city: 'Navi Mumbai',
    text: 'The flowers arrived fresh and beautifully arranged. Perfect surprise for my girlfriend.',
    rating: 5
  },
  {
    name: 'Snehal Patil',
    city: 'Vashi',
    text: 'Loved the colourful bouquet. The flowers were fresh and the presentation was excellent.',
    rating: 4
  },
  {
    name: 'Yash Thakur',
    city: 'Nerul',
    text: 'The red rose bouquet was stunning. Fresh roses, beautiful wrapping and great service.',
    rating: 5
  },
  {
    name: 'Mansi Shah',
    city: 'Belapur',
    text: 'Ordered orchids for my mother. The flowers were fresh and looked very elegant.',
    rating: 4.5
  },
  {
    name: 'Karan Arora',
    city: 'Kharghar',
    text: 'The bouquet was beautiful and delivery was right on time. My friend loved the surprise!',
    rating: 5
  },
  {
    name: 'Ritika Deshmukh',
    city: 'Panvel',
    text: 'Beautiful combination of roses and lilies. The flowers were fresh and nicely packed.',
    rating: 5
  },
  {
    name: 'Mohit Agarwal',
    city: 'Airoli',
    text: 'Very happy with the quality of flowers. The bouquet looked fresh and premium.',
    rating: 4
  },
  {
    name: 'Sakshi Joshi',
    city: 'Ghansoli',
    text: 'The purple orchids were absolutely beautiful. They made a lovely birthday surprise.',
    rating: 5
  },
  {
    name: 'Abhishek Rao',
    city: 'Koparkhairane',
    text: 'Fresh flowers and beautiful presentation. The bouquet looked exactly like the pictures.',
    rating: 4.8
  },
  {
    name: 'Pritam Das',
    city: 'Thane West',
    text: 'The red roses were fresh and fragrant. The arrangement looked very elegant.',
    rating: 5
  },
  {
    name: 'Rhea Fernandes',
    city: 'Thane East',
    text: 'Ordered a flower basket for my parents. They loved the beautiful mix of flowers.',
    rating: 4.5
  },
  {
    name: 'Nitin Kumar',
    city: 'Kalyan',
    text: 'Very fresh flowers and excellent packaging. The bouquet was delivered safely.',
    rating: 5
  },
  {
    name: 'Sonal Gupta',
    city: 'Dombivli',
    text: 'The pink and white flower arrangement was gorgeous. Perfect for a special occasion.',
    rating: 5
  },
  {
    name: 'Vishal Patil',
    city: 'Dombivli East',
    text: 'The bouquet was fresh, colourful and beautifully wrapped. Very happy with the order.',
    rating: 5
  },
  {
    name: 'Shruti More',
    city: 'Dombivli West',
    text: 'Ordered red roses for an anniversary. The flowers were fresh and the arrangement was lovely.',
    rating: 4
  },
  {
    name: 'Rakesh Tiwari',
    city: 'Bhiwandi',
    text: 'Good quality flowers and beautiful presentation. The recipient was very happy.',
    rating: 5
  },
  {
    name: 'Isha Kulkarni',
    city: 'Ambernath',
    text: 'The mixed flower basket was beautiful. Fresh flowers and great colour combination.',
    rating: 4.5
  },
  {
    name: 'Sameer Khan',
    city: 'Badlapur',
    text: 'The rose bouquet looked premium and the flowers were very fresh. Highly recommended.',
    rating: 5
  },
  {
    name: 'Aditi Joshi',
    city: 'Mahalaxmi',
    text: 'The white lilies were gorgeous and had a lovely fragrance. Beautiful flower arrangement.',
    rating: 5
  },
  {
    name: 'Rahul Khanna',
    city: 'Colaba',
    text: 'The premium rose bouquet was stunning. The flowers looked fresh and elegant.',
    rating: 4.8
  },
  {
    name: 'Madhuri Rao',
    city: 'Fort',
    text: 'Ordered a bouquet for a special occasion. The flowers were beautiful and perfectly arranged.',
    rating: 5
  },
  {
    name: 'Vivek Nair',
    city: 'Marine Lines',
    text: 'The orchid and rose combination looked amazing. Very fresh and beautifully presented.',
    rating: 4
  },
  {
    name: 'Kriti Sharma',
    city: 'Matunga',
    text: 'The bouquet was beautiful and arrived fresh. It made my sister’s birthday very special.',
    rating: 5
  },
  {
    name: 'Rajat Mehta',
    city: 'Sion',
    text: 'Excellent flower quality and lovely packaging. Would definitely order again.',
    rating: 4.5
  },
  {
    name: 'Neelam Joshi',
    city: 'Wadala',
    text: 'The red and white roses looked stunning. The arrangement was neat and elegant.',
    rating: 5
  },
  {
    name: 'Ankit Verma',
    city: 'Kurla',
    text: 'Fresh flowers, beautiful bouquet and good delivery service. Very satisfied with the order.',
    rating: 5
  },
  {
    name: 'Pooja Sharma',
    city: 'Bandra West',
    text: 'The rose bouquet was simply beautiful. Fresh petals and a very elegant presentation.',
    rating: 4
  },
  {
    name: 'Rohan Kapoor',
    city: 'Bandra East',
    text: 'Ordered flowers for my wife and the surprise was perfect. Beautiful fresh roses!',
    rating: 5
  },
  {
    name: 'Nandini Shah',
    city: 'Powai',
    text: 'The flower basket looked amazing and had a wonderful mix of colours. Loved it!',
    rating: 4.8
  },
  {
    name: 'Manav Patel',
    city: 'Mulund West',
    text: 'The lilies were fresh and beautiful. The bouquet was packed very nicely.',
    rating: 5
  },
  {
    name: 'Kajal Singh',
    city: 'Borivali West',
    text: 'The flowers were fresh and the bouquet looked beautiful from every angle.',
    rating: 4.5
  },
  {
    name: 'Amit Joshi',
    city: 'Borivali East',
    text: 'Excellent red roses and very nice arrangement. My wife loved the surprise.',
    rating: 5
  },
  {
    name: 'Ritu Malhotra',
    city: 'Kandivali West',
    text: 'The pink flower bouquet was gorgeous. Fresh, colourful and beautifully wrapped.',
    rating: 5
  },
  {
    name: 'Sanjay Shah',
    city: 'Kandivali East',
    text: 'Really happy with the quality. The roses were fresh and the bouquet looked premium.',
    rating: 5
  }
];

// ---------------------------------------------------------------------------
// Search suggestions — fallback for searchProducts(). Real data: admin > Search Terms.
// ---------------------------------------------------------------------------
export const searchSuggestions = [
  'red roses bouquet',
  'birthday flower bouquet',
  'anniversary flowers',
  'fresh flower bouquet',
  'same day flower delivery',
  'premium flower bouquet',
  'orchid bouquet',
  'flower delivery in Mumbai',
];

// ---------------------------------------------------------------------------
// Video testimonials — fallback for getVideoTestimonials(). Real data: admin > Video Testimonials.
// ---------------------------------------------------------------------------
export const videoTestimonials = [
  { id: 'v1', thumb: 'https://images.unsplash.com/photo-1587533042502-1209d3f2d891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85', title: 'Reactions before delivery',     customer: 'Ananya S.' },
  { id: 'v2', thumb: 'https://images.unsplash.com/photo-1715619048248-4c0c3ece2230?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85', title: 'Unboxing the ocean wall art',    customer: 'Riya K.'   },
  { id: 'v3', thumb: 'https://images.pexels.com/photos/11066021/pexels-photo-11066021.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', title: 'Make every wall a canvas',       customer: 'Vikram R.' },
  { id: 'v4', thumb: 'https://images.pexels.com/photos/7258058/pexels-photo-7258058.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',   title: 'Living room makeover',           customer: 'Priya N.'  },
];

// ---------------------------------------------------------------------------
// Shop by shape — fallback for getShapes(). Real data: admin > Shapes.
// ---------------------------------------------------------------------------
export const shapes = [
  { id: 'round',       name: 'Round',       image: clocks[0] },
  { id: 'rectangular', name: 'Rectangular', image: dining[3] },
  { id: 'square',      name: 'Square',      image: 'https://images.unsplash.com/photo-1587533042502-1209d3f2d891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85' },
  { id: 'oval',        name: 'Oval',        image: dining[3] },
];